import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

// Extend Window interface to include dataLayer
declare global {
  interface Window {
    dataLayer: any[];
  }
}

/**
 * Custom hook to track page views with Google Tag Manager
 * Pushes page_view events to dataLayer on route changes
 */
const usePageViewTracking = () => {
  const location = useLocation();

  useEffect(() => {
    // Initialize dataLayer if it doesn't exist
    window.dataLayer = window.dataLayer || [];

    // Push page view event to GTM dataLayer
    window.dataLayer.push({
      event: 'page_view',
      page: location.pathname + location.search,
      page_title: document.title,
      page_location: window.location.href,
    });

    // Optional: Log for debugging
    // console.log('GTM Page View:', {
    //   event: 'page_view',
    //   page: location.pathname + location.search,
    //   page_title: document.title,
    // });
  }, [location.pathname, location.search]);
};

export default usePageViewTracking;